import api from "./api";

export interface ProjetoCliente {
  id: string;
  nome: string;
  status: string;
  dataInicio: string;
  prazoEntrega: string;
  resumoPublico: string | null;
  marcos: number;
  marcosConcluidos: number;
  tarefasVisiveis: number;
  tarefasConcluidas: number;
  progresso: number;
}

export interface MarcoCliente {
  id: string;
  nome: string;
  descricao: string | null;
  dataPrevista: string;
  dataRealizada: string | null;
  status: string;
}

export interface TarefaCliente {
  id: string;
  titulo: string;
  status: string;
  prazo: string;
  concluidaEm: string | null;
}

export interface AnexoCliente {
  id: string;
  tipo: "imagem" | "audio" | "video" | "documento";
  url: string;
  nomeOriginal: string;
  mimeType: string;
  tamanhoBytes: number;
  descricao: string | null;
  criadoEm: string;
}

export interface ComentarioCliente {
  id: string;
  texto: string;
  criadoEm: string;
  autor: { id: string; nome: string; perfil: string };
}

export interface ProjetoClienteDetalhe {
  id: string;
  nome: string;
  status: string;
  dataInicio: string;
  prazoEntrega: string;
  resumoPublico: string | null;
  criadoEm: string;
  atualizadoEm: string;
  marcos: MarcoCliente[];
  tarefas: TarefaCliente[];
  anexos: AnexoCliente[];
  comentarios: ComentarioCliente[];
}

export async function listarProjetosCliente() {
  const r = await api.get("/cliente/projetos");
  return r.data.data as ProjetoCliente[];
}

export async function buscarProjetoCliente(id: string) {
  const r = await api.get(`/cliente/projetos/${id}`);
  return r.data.data as ProjetoClienteDetalhe;
}

export interface DocumentoCliente {
  id: string;
  titulo: string;
  descricao: string | null;
  status: string;
  arquivoUrl: string;
  arquivoFinalUrl: string | null;
  arquivoHash: string;
  arquivoFinalHash: string | null;
  codigoVerificacao: string;
  importado: boolean;
  finalizadoEm: string | null;
  criadoEm: string;
  signatarios: Array<{
    nome: string;
    email: string;
    status: string;
    assinadoEm: string | null;
    papel: string | null;
    tokenAcesso: string | null; // só do próprio cliente
  }>;
}

export async function listarDocumentosClienteProjeto(projetoId: string) {
  const r = await api.get(`/cliente/projetos/${projetoId}/assinaturas`);
  return r.data.data as DocumentoCliente[];
}
